import React, { useState } from 'react';
import { Layout, Typography, Badge, Space, Avatar, Tabs, Card, Button, List, Tag, Statistic, Row, Col } from 'antd';
import { 
  UserOutlined, 
  BellOutlined, 
  HomeOutlined, 
  TeamOutlined, 
  PhoneOutlined,
  MailOutlined,
  LogoutOutlined,
  SettingOutlined,
  ShopOutlined,
  DollarCircleOutlined,
  RiseOutlined,
  CalendarOutlined,
  CrownOutlined,
  GiftOutlined
} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;
const { Title, Text, Paragraph } = Typography;

/**
 * 员工移动应用容器组件
 */
const MobileEmployeeApp: React.FC = () => {
  const [activeTab, setActiveTab] = useState('home');
  
  // 模拟未读通知数量
  const notificationCount = 5;
  
  // 模拟员工信息
  const employeeInfo = {
    name: '张经理',
    position: '资深客户管家',
    employeeId: 'EMP20230001',
    department: '客户服务部',
    phone: '13912345678',
    email: 'zhang@qiuguohotel.com',
    avatar: null
  };

  // 模拟绩效指标
  const performanceStats = {
    servedMembers: 42,
    totalRevenue: 158680,
    growthRate: 15.8,
    completedOrders: 86
  };

  // 模拟服务的高价值会员
  const highValueMembers = [
    {
      id: 'M001',
      name: '刘先生',
      level: '钻石会员',
      totalSpent: 58900,
      recentContact: '2023-05-03'
    },
    {
      id: 'M002',
      name: '张女士',
      level: '铂金会员',
      totalSpent: 42600,
      recentContact: '2023-05-01'
    },
    {
      id: 'M003',
      name: '王总',
      level: '钻石会员',
      totalSpent: 63400,
      recentContact: '2023-04-28'
    }
  ];

  // 模拟今日任务
  const todayTasks = [
    {
      id: 'T001',
      title: '联系张先生确认5月10日入住偏好',
      priority: '高',
      time: '14:00'
    },
    {
      id: 'T002',
      title: '跟进李女士投诉处理结果',
      priority: '高',
      time: '15:30'
    },
    {
      id: 'T003',
      title: '准备月度会员活动提案',
      priority: '中',
      time: '16:00'
    }
  ];

  // 渲染底部导航
  const renderFooter = () => {
    return (
      <Footer style={{ padding: 0, backgroundColor: '#fff', borderTop: '1px solid #f0f0f0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-around', padding: '8px 0' }}>
          <div 
            onClick={() => setActiveTab('home')} 
            style={{ textAlign: 'center', color: activeTab === 'home' ? '#529C8A' : '#999' }}
          >
            <HomeOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>首页</div>
          </div>
          <div 
            onClick={() => setActiveTab('customers')} 
            style={{ textAlign: 'center', color: activeTab === 'customers' ? '#529C8A' : '#999' }}
          >
            <TeamOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>会员</div>
          </div>
          <div 
            onClick={() => setActiveTab('notifications')} 
            style={{ textAlign: 'center', color: activeTab === 'notifications' ? '#529C8A' : '#999' }}
          >
            <Badge count={notificationCount} size="small">
              <BellOutlined style={{ fontSize: 20 }} />
            </Badge>
            <div style={{ fontSize: 12 }}>消息</div>
          </div>
          <div 
            onClick={() => setActiveTab('profile')} 
            style={{ textAlign: 'center', color: activeTab === 'profile' ? '#529C8A' : '#999' }}
          >
            <UserOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>我的</div>
          </div>
        </div>
      </Footer>
    );
  };

  // 渲染员工首页
  const renderHome = () => {
    return (
      <div style={{ padding: '0 16px 16px' }}>
        <Card 
          style={{ 
            marginTop: 16, 
            borderRadius: 8,
            background: 'linear-gradient(135deg, #38547B 0%, #1E2F45 100%)',
            color: '#fff'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar size={60} icon={<UserOutlined />} />
            <div style={{ marginLeft: 16 }}>
              <div style={{ fontSize: 18, fontWeight: 'bold' }}>{employeeInfo.name}</div>
              <div style={{ marginTop: 4 }}>
                <Tag color="blue">{employeeInfo.position}</Tag>
                <Text style={{ color: '#fff', marginLeft: 8 }}>{employeeInfo.department}</Text>
              </div>
            </div>
          </div>
        </Card>
        
        <div style={{ marginTop: 16 }}>
          <Title level={5}>绩效概览</Title>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Card>
                <Statistic 
                  title="服务会员数" 
                  value={performanceStats.servedMembers} 
                  prefix={<TeamOutlined />} 
                  valueStyle={{ color: '#1890ff' }}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic 
                  title="订单完成率" 
                  value={performanceStats.completedOrders} 
                  suffix="%" 
                  precision={0}
                  valueStyle={{ color: '#3f8600' }}
                  prefix={<RiseOutlined />}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic 
                  title="营收贡献" 
                  value={performanceStats.totalRevenue} 
                  prefix={<DollarCircleOutlined />}
                  valueStyle={{ color: '#cf1322' }}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic 
                  title="营收增长率" 
                  value={performanceStats.growthRate} 
                  suffix="%" 
                  precision={1}
                  valueStyle={{ color: '#3f8600' }}
                  prefix={<RiseOutlined />}
                />
              </Card>
            </Col>
          </Row>
        </div>
        
        <div style={{ marginTop: 16 }}>
          <Title level={5}>今日任务</Title>
          <List
            itemLayout="horizontal"
            dataSource={todayTasks}
            renderItem={task => (
              <List.Item>
                <Card style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CalendarOutlined />
                        <Text strong style={{ marginLeft: 8 }}>{task.time}</Text>
                        <Tag 
                          color={task.priority === '高' ? 'red' : task.priority === '中' ? 'orange' : 'green'} 
                          style={{ marginLeft: 8 }}
                        >
                          {task.priority}优先级
                        </Tag>
                      </div>
                      <Paragraph style={{ marginTop: 8 }}>{task.title}</Paragraph>
                    </div>
                    <Button size="small" type="primary">完成</Button>
                  </div>
                </Card>
              </List.Item>
            )}
          />
        </div>
        
        <div style={{ marginTop: 16 }}>
          <Title level={5}>高价值会员跟进</Title>
          <List
            itemLayout="horizontal"
            dataSource={highValueMembers}
            renderItem={member => (
              <List.Item>
                <Card style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
                        <div style={{ marginLeft: 12 }}>
                          <Text strong>{member.name}</Text>
                          <div>
                            <Tag color="gold">
                              <CrownOutlined /> {member.level}
                            </Tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 'bold', color: '#529C8A' }}>¥{member.totalSpent.toLocaleString()}</div>
                      <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                        最近联系: {member.recentContact}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button size="small" icon={<PhoneOutlined />}>联系</Button>
                    <Button size="small" type="primary">查看</Button>
                  </div>
                </Card>
              </List.Item>
            )}
          />
          <div style={{ textAlign: 'center', marginTop: 12 }}>
            <Button type="link">查看全部会员</Button>
          </div>
        </div>

        <div style={{ marginTop: 16 }}>
          <Title level={5}>最新活动</Title>
          <Card style={{ borderRadius: 8, background: '#f6ffed', borderLeft: '4px solid #52c41a' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <GiftOutlined style={{ fontSize: 24, color: '#52c41a' }} />
              <div style={{ marginLeft: 12 }}>
                <Text strong>夏季酒店套餐优惠活动</Text>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                  6月1日-7月31日，限时促销
                </div>
              </div>
            </div>
            <Paragraph style={{ marginTop: 8 }}>
              推广限时特惠套餐，享受8折优惠，同时可获得餐饮代金券。
            </Paragraph>
            <Button size="small" type="primary">查看详情</Button>
          </Card>
        </div>
      </div>
    );
  };

  // 渲染员工促销资讯
  const renderPromotion = () => {
    return (
      <div style={{ padding: 16 }}>
        <Title level={4}>促销活动</Title>
        <Card style={{ marginBottom: 16, borderRadius: 8, background: '#f6ffed', borderLeft: '4px solid #52c41a' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <GiftOutlined style={{ fontSize: 24, color: '#52c41a' }} />
            <div style={{ marginLeft: 12 }}>
              <Text strong>夏季酒店套餐优惠活动</Text>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                6月1日-7月31日，限时促销
              </div>
            </div>
          </div>
          <Paragraph style={{ marginTop: 8 }}>
            推广限时特惠套餐，享受8折优惠，同时可获得餐饮代金券。适合向所有会员推广。
          </Paragraph>
          <div>
            <Tag color="purple">夏季特惠</Tag>
            <Tag color="blue">住宿优惠</Tag>
            <Tag color="orange">餐饮赠券</Tag>
          </div>
          <div style={{ marginTop: 12 }}>
            <Button size="small" type="primary" style={{ marginRight: 8 }}>立即推广</Button>
            <Button size="small">活动详情</Button>
          </div>
        </Card>
        
        <Card style={{ marginBottom: 16, borderRadius: 8, background: '#fff7e6', borderLeft: '4px solid #fa8c16' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ShopOutlined style={{ fontSize: 24, color: '#fa8c16' }} />
            <div style={{ marginLeft: 12 }}>
              <Text strong>高端会员专享SPA礼遇</Text>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                5月15日-6月30日，铂金会员及以上
              </div>
            </div>
          </div>
          <Paragraph style={{ marginTop: 8 }}>
            为铂金及钻石会员提供专属SPA体验，入住即可享受60分钟精油按摩免费体验。
          </Paragraph>
          <div>
            <Tag color="gold">高端专享</Tag>
            <Tag color="blue">SPA体验</Tag>
            <Tag color="green">免费礼遇</Tag>
          </div>
          <div style={{ marginTop: 12 }}>
            <Button size="small" type="primary" style={{ marginRight: 8 }}>向会员推荐</Button>
            <Button size="small">活动详情</Button>
          </div>
        </Card>
        
        <Card style={{ marginBottom: 16, borderRadius: 8, background: '#f0f5ff', borderLeft: '4px solid #2f54eb' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CalendarOutlined style={{ fontSize: 24, color: '#2f54eb' }} />
            <div style={{ marginLeft: 12 }}>
              <Text strong>提前预订优惠计划</Text>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                长期有效，提前30天预订
              </div>
            </div>
          </div>
          <Paragraph style={{ marginTop: 8 }}>
            提前30天预订任意房型，可享受7.5折优惠，提前60天预订可享受7折优惠。
          </Paragraph>
          <div>
            <Tag color="blue">提前预订</Tag>
            <Tag color="red">折扣优惠</Tag>
            <Tag color="cyan">长期有效</Tag>
          </div>
          <div style={{ marginTop: 12 }}>
            <Button size="small" type="primary" style={{ marginRight: 8 }}>立即推广</Button>
            <Button size="small">活动详情</Button>
          </div>
        </Card>
      </div>
    );
  };

  // 渲染主要内容
  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return renderHome();
      case 'customers':
        return (
          <div style={{ padding: 16, textAlign: 'center' }}>
            <Title level={4}>会员管理</Title>
            <div style={{ marginTop: 40, marginBottom: 40 }}>
              <Text type="secondary">加载会员列表中...</Text>
            </div>
            <Button type="primary">查看会员列表</Button>
          </div>
        );
      case 'notifications':
        return (
          <div style={{ padding: 16 }}>
            <Title level={4}>消息中心</Title>
            <Tabs defaultActiveKey="all">
              <Tabs.TabPane tab="全部" key="all">
                <List
                  itemLayout="horizontal"
                  dataSource={[
                    {
                      id: 'N001',
                      title: '系统通知: 促销活动更新',
                      content: '夏季促销活动已更新，请查看最新活动详情并向会员推广',
                      time: '今天 09:30',
                      isRead: false
                    },
                    {
                      id: 'N002',
                      title: '会员请求: 张先生咨询套房预订',
                      content: '钻石会员张先生希望了解6月10日豪华套房的预订情况',
                      time: '今天 08:45',
                      isRead: false
                    },
                    {
                      id: 'N003',
                      title: '任务提醒: 会员满意度回访',
                      content: '请在今天完成李女士的入住满意度回访',
                      time: '昨天 16:20',
                      isRead: false
                    },
                    {
                      id: 'N004',
                      title: '绩效提醒: 本月业绩已达标',
                      content: '恭喜您已完成本月绩效目标，继续保持！',
                      time: '昨天 10:15',
                      isRead: true
                    },
                    {
                      id: 'N005',
                      title: '系统通知: 员工培训安排',
                      content: '下周三将进行新系统使用培训，请准时参加',
                      time: '2023-05-01 14:30',
                      isRead: true
                    }
                  ]}
                  renderItem={item => (
                    <List.Item>
                      <Card 
                        style={{ 
                          width: '100%', 
                          background: item.isRead ? '#fff' : '#f0f7ff',
                          borderLeft: item.isRead ? 'none' : '3px solid #1890ff'
                        }}
                      >
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text strong>{item.title}</Text>
                            {!item.isRead && <Badge color="blue" />}
                          </div>
                          <Paragraph style={{ marginTop: 8 }}>{item.content}</Paragraph>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>{item.time}</Text>
                            {!item.isRead ? (
                              <Button size="small" type="primary">标记已读</Button>
                            ) : (
                              <Button size="small">删除</Button>
                            )}
                          </div>
                        </div>
                      </Card>
                    </List.Item>
                  )}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="未读" key="unread">
                <List
                  itemLayout="horizontal"
                  dataSource={[
                    {
                      id: 'N001',
                      title: '系统通知: 促销活动更新',
                      content: '夏季促销活动已更新，请查看最新活动详情并向会员推广',
                      time: '今天 09:30',
                      isRead: false
                    },
                    {
                      id: 'N002',
                      title: '会员请求: 张先生咨询套房预订',
                      content: '钻石会员张先生希望了解6月10日豪华套房的预订情况',
                      time: '今天 08:45',
                      isRead: false
                    },
                    {
                      id: 'N003',
                      title: '任务提醒: 会员满意度回访',
                      content: '请在今天完成李女士的入住满意度回访',
                      time: '昨天 16:20',
                      isRead: false
                    }
                  ]}
                  renderItem={item => (
                    <List.Item>
                      <Card 
                        style={{ 
                          width: '100%', 
                          background: '#f0f7ff',
                          borderLeft: '3px solid #1890ff'
                        }}
                      >
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text strong>{item.title}</Text>
                            <Badge color="blue" />
                          </div>
                          <Paragraph style={{ marginTop: 8 }}>{item.content}</Paragraph>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>{item.time}</Text>
                            <Button size="small" type="primary">标记已读</Button>
                          </div>
                        </div>
                      </Card>
                    </List.Item>
                  )}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="系统通知" key="system">
                <List
                  itemLayout="horizontal"
                  dataSource={[
                    {
                      id: 'N001',
                      title: '系统通知: 促销活动更新',
                      content: '夏季促销活动已更新，请查看最新活动详情并向会员推广',
                      time: '今天 09:30',
                      isRead: false
                    },
                    {
                      id: 'N005',
                      title: '系统通知: 员工培训安排',
                      content: '下周三将进行新系统使用培训，请准时参加',
                      time: '2023-05-01 14:30',
                      isRead: true
                    }
                  ]}
                  renderItem={item => (
                    <List.Item>
                      <Card 
                        style={{ 
                          width: '100%', 
                          background: item.isRead ? '#fff' : '#f0f7ff',
                          borderLeft: item.isRead ? 'none' : '3px solid #1890ff'
                        }}
                      >
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text strong>{item.title}</Text>
                            {!item.isRead && <Badge color="blue" />}
                          </div>
                          <Paragraph style={{ marginTop: 8 }}>{item.content}</Paragraph>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>{item.time}</Text>
                            {!item.isRead ? (
                              <Button size="small" type="primary">标记已读</Button>
                            ) : (
                              <Button size="small">删除</Button>
                            )}
                          </div>
                        </div>
                      </Card>
                    </List.Item>
                  )}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
        );
      case 'profile':
        return (
          <div style={{ padding: 16 }}>
            <Title level={4}>个人中心</Title>
            <Card style={{ marginTop: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar size={64} icon={<UserOutlined />} />
                <div style={{ marginLeft: 16 }}>
                  <Text strong style={{ fontSize: 18 }}>{employeeInfo.name}</Text>
                  <div style={{ marginTop: 4 }}>
                    <Tag color="blue">{employeeInfo.position}</Tag>
                    <Tag color="cyan">{employeeInfo.department}</Tag>
                  </div>
                  <div style={{ marginTop: 8, color: '#666', fontSize: 14 }}>
                    工号: {employeeInfo.employeeId}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 24 }}>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                    <PhoneOutlined style={{ marginRight: 8 }} />
                    <Text>{employeeInfo.phone}</Text>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <MailOutlined style={{ marginRight: 8 }} />
                    <Text>{employeeInfo.email}</Text>
                  </div>
                </div>
              </div>
            </Card>
            
            <Title level={5} style={{ marginTop: 24 }}>账户操作</Title>
            <List>
              <List.Item>
                <Button type="text" icon={<SettingOutlined />} block style={{ textAlign: 'left' }}>
                  账户设置
                </Button>
              </List.Item>
              <List.Item>
                <Button type="text" icon={<BellOutlined />} block style={{ textAlign: 'left' }}>
                  通知设置
                </Button>
              </List.Item>
              <List.Item>
                <Button type="text" icon={<LogoutOutlined />} danger block style={{ textAlign: 'left' }}>
                  退出登录
                </Button>
              </List.Item>
            </List>
          </div>
        );
      default:
        return renderHome();
    }
  };

  return (
    <Layout style={{ height: '100vh', width: '100%', maxWidth: 500, margin: '0 auto', background: '#f5f5f5' }}>
      <Header style={{ 
        background: '#fff', 
        padding: '0 16px', 
        height: 56, 
        lineHeight: '56px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Title level={4} style={{ margin: 0 }}>秋果酒店·员工端</Title>
        <Space>
          <Badge count={notificationCount}>
            <BellOutlined style={{ fontSize: 18 }} />
          </Badge>
        </Space>
      </Header>
      <Content style={{ flex: 1, overflowY: 'auto' }}>
        {renderContent()}
      </Content>
      {renderFooter()}
    </Layout>
  );
};

export default MobileEmployeeApp; 